module.exports = __webpack_public_path__ + "img/CBQ.5ae96a90.jpg";